import React from "react";
import Page from "../../Components/Page";
import {Breadcrumbs} from "../../Components/Breadcrumbs";
import {getStringParamOrDefault} from "../../../utils/urlBuilder";
import ReactTable from "../../Components/ReactTable";
import {useServiceBase} from "../../Components/ReactTable/useServiceBase";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import CsvDownload from "../../../utils/CsvDownloadWithNulls";

function MAPMerchants() {
    const brandId = getStringParamOrDefault('brandId');
    const brandName = getStringParamOrDefault('brandName');
    const asin = getStringParamOrDefault('asin');

    const startDate = getStringParamOrDefault('startDate', '');
    const endDate = getStringParamOrDefault('endDate', '');

    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/merchantsByAsin?asin=${asin}&start_date=${startDate}&end_date=${endDate}`;
    const {loading, data} = useServiceBase({endpointUrl});

    const customColumns = [
        {
            header: "Merchant ID",
            filterable: true,
            accessorKey: "merchant_id",
        },
        {
            header: "Merchant Name",
            filterable: true,
            accessorKey: "merchant_name"
        },
        {
            header: "Price",
            filterable: true,
            accessorKey: "price"
        },
        {
            header: "MAP",
            filterable: true,
            accessorKey: "enforcement_price"
        },
        {
            header: "FBA",
            filterable: true,
            accessorKey: "fba_violation"
        },
        {
            header: "Promo",
            filterable: true,
            accessorKey: "promo"
        },
        {
            header: "Date",
            filterable: true,
            accessorKey: "scrape_date"
        }
    ]

    function transformData(data) {
        function remove_unwanted_characters(item) {
            if (item) {
                return item.replace(/[\n\r]/g, "");
            }
        }

        return data.map(item => ({
            "Merchant ID": item.merchant_id,
            "Merchant Name": item.merchant_name,
            "Price": item.price,
            "MAP": item.enforcement_price,
            "FBA": item.fba_violation,
            "Promo": item.promo,
            "Date": remove_unwanted_characters(item.scrape_date),
        }));

    }
    function downloadCsv() {
        if (!loading)
            CsvDownload(transformData(data), `MAPMerchants_${asin}.csv`)
    }

    return (
        <Page name={
            <>
                Asin:{" "}
                <a
                    href={`https://www.amazon.com/dp/${asin}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {asin}
                </a>{" "}
                - ({startDate} to {endDate})
            </>
        }
              breadCrumbs={<Breadcrumbs items={[
                  {label: "MAP Enforcement Dashboard", to: '/mapEnforcementDashboard/'},
                  {label: "MAP Asins", to: `/mapAsins/${brandId}?brandName=${brandName}&startDate=${startDate}&endDate=${endDate}`},
                  {label: "MAP Merchants"}
              ]}/>}
        >
            <div className='client-dashboard-download-csv-button-container'>
                <button
                    className='button'
                    data-testid={'map-asins-download-csv-button'}
                    onClick={() => {
                        downloadCsv()
                    }}
                >

                    Export Csv
                </button>
            </div>

            <LoadingWrapper loading={loading}>
                <ReactTable
                    filterable
                    data={data}
                    columns={customColumns}
                    initialState={{
                        pagination: {pageSize: 25},
                        sorting: [{id: "merchant_name", desc: false}]
                    }}
                />
            </LoadingWrapper>
        </Page>
    );
}

export default MAPMerchants;